import { CompositeDecorator } from 'draft-js';
import {
  Link,
} from 'react-router';
import { ContentState, ContentBlock, CharacterMetadata } from 'draft-js';
import { ReactNode } from 'react';

interface LinkComponentProps {
  entityKey: string;
  contentState: ContentState;
  children: ReactNode;
}

const LinkComponent = ({ entityKey, contentState, children }: LinkComponentProps) => {
  const { url } = contentState.getEntity(entityKey).getData();
  if (url.indexOf('document:') !== -1) {
    return <Link to={`/documents/${url.split(':')[1]}`}>{children}</Link>;
  } else if (url.startsWith('http://') || url.startsWith('https://')) {
    return (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
      >
        {children}
      </a>
    )
  }

  return '';
};

const findLinkEntities = (
  contentBlock: ContentBlock,
  callback: (start: number, end: number) => void,
  contentState: ContentState
) => contentBlock.findEntityRanges(
  (character: CharacterMetadata) => {
    const entityKey = character.getEntity();
    return (
      entityKey !== null
      && contentState.getEntity(entityKey).getType() === 'LINK'
    );
  },
  callback,
);

const linkDecorator = new CompositeDecorator([
  {
    strategy: findLinkEntities,
    component: LinkComponent,
  },
]);

export default linkDecorator;
